enum ProviderIcons {
  METABASE = '/images/logomarks/metabase.svg',
  METABASE_LOCK = '/images/logomarks/metabase-lock.svg',
  AMAZON_SAGEMAKER = '/images/logomarks/amazon-sagemaker.svg',
  AIRBYTE = '/images/logomarks/airbyte.svg',
  AIRBYTE_LOCK = '/images/logomarks/airbyte-lock.svg',
  CENSUS = '/images/logomarks/census.svg',
  CENSUS_LOCK = '/images/logomarks/census-lock.svg',
  HIGH_TOUCH = '/images/logomarks/hightouch.svg',
  HIGH_TOUCH_LOCK = '/images/logomarks/hightouch-lock.svg',
  SALESFORCE = '/images/logomarks/salesforce.svg',
  SEGMENT = '/images/logomarks/segment.svg',
  EXCEL = '/images/logomarks/excel.svg',
  GOOGLE_ANALYTICS = '/images/logomarks/google-analytics.svg',
  BIGQUERY = '/images/datasources/light/bigquery.svg',
  DBTCLOUD = '/images/datasources/light/dbtcloud.svg',
  MYSQL_LOCK = '/images/datasources/light/mysql-lock.svg',
  POWER_BI = '/images/datasources/light/powerbi.svg',
  POWER_BI_LOCK = '/images/datasources/light/powerbi-lock.svg',
  SLACK = '/images/datasources/light/slack.svg',
  TABLEAU = '/images/datasources/light/tableau.svg',
  CENSUS_LOCK_COLOR = '/images/datasources/light/census-lock-color.svg',
  FIREBOLT_LOCK_COLOR = '/images/datasources/light/firebolt-lock-color.svg',
  HDFS_STORAGE = '/images/datasources/light/hdfs-storage.svg',
  MYSQL = '/images/datasources/light/mysql.svg',
  H2 = '/images/datasources/light/mysql.svg',
  PREFECT = '/images/datasources/light/prefect.svg',
  PREFECT_LOCK = '/images/datasources/light/prefect-lock.svg',
  SNOWFLAKE_LOCK = '/images/datasources/light/snowflake-lock.svg',
  AIRFLOW_LOCK = '/images/datasources/light/airflow-lock.svg',
  COMPOSER_LOCK = '/images/datasources/light/composer-lock.svg',
  MWAA_LOCK = '/images/datasources/light/mwaa-lock.svg',
  DAGSTER = '/images/datasources/light/dagster.svg',
  DAGSTER_LOCK = '/images/datasources/light/dagster-lock.svg',
  FIREBOLT_LOCK = '/images/datasources/light/firebolt-lock.svg',
  HIGHTOUCH_LOCK = '/images/datasources/light/hightouch-lock.svg',
  ORACLE = '/images/datasources/light/oracle.svg',
  PRESTO = '/images/datasources/light/presto.svg',
  PRESTO_LOCK = '/images/datasources/light/presto-lock.svg',
  SNOWFLAKE = '/images/datasources/light/snowflake.svg',
  AIRFLOW = '/images/datasources/light/airflow.svg',
  COMPOSER = '/images/datasources/light/composer.svg',
  MWAA = '/images/datasources/light/mwaa.svg',
  FIREBOLT = '/images/datasources/light/firebolt.svg',
  POSTGRES_LOCK = '/images/datasources/light/postgres-lock.svg',
  QUICKSIGHT_LOCK = '/images/datasources/light/quicksight-lock.svg',
  SPARK_PROCESS = '/images/datasources/light/spark-process.svg',
  ATHENA_LOCK = '/images/datasources/light/athena-lock.svg',
  DATABRICKS = '/images/datasources/light/databricks.svg',
  DATABRICKS_LOCK = '/images/datasources/light/databricks-lock.svg',
  DATABRICKS_JOBS = '/images/datasources/light/databricks_jobs.svg',
  DATABRICKS_JOBS_LOCK = '/images/datasources/light/databricks-lock.svg',
  ADF = '/images/datasources/light/adf.svg',
  ADF_LOCK = '/images/datasources/light/adf-lock.svg',
  FIVETRAN_LOCK = '/images/datasources/light/fivetran-lock.svg',
  POSTGRES = '/images/datasources/light/postgres.svg',
  QUICKSIGHT = '/images/datasources/light/quicksight.svg',
  SQLSERVER_LOCK = '/images/datasources/light/sqlserver-lock.svg',
  ATHENA = '/images/datasources/light/athena.svg',
  DBT_LOCK = '/images/datasources/light/dbt-lock.svg',
  FIVETRAN = '/images/datasources/light/fivetran.svg',
  LOOKER_LOCK = '/images/datasources/light/looker-lock.svg',
  REDSHIFT_LOCK = '/images/datasources/light/redshift-lock.svg',
  STITCH = '/images/logomarks/stitch.svg',
  STITCH_LOCK = '/images/logomarks/stitch-lock.svg',
  AZURE = '/images/logomarks/microsoft-azure.svg',
  AZURE_LOCK = '/images/logomarks/microsoft-azure-lock.svg',
  DBT = '/images/datasources/light/dbt.svg',
  GOOGLE_CLOUD_STORAGE = '/images/datasources/light/google-cloud-storage.svg',
  LOOKER = '/images/datasources/light/looker.svg',
  REDSHIFT = '/images/datasources/light/redshift.svg',
  SYNAPSE = '/images/datasources/light/synapse.svg',
  BIGQUERY_LOCK = '/images/datasources/light/bigquery-lock.svg',
  DBTCLOUD_LOCK = '/images/datasources/light/dbtcloud-lock.svg',
  GOOGLE_DRIVE = '/images/datasources/light/google-drive.svg',
  MSSQL = '/images/datasources/light/mssql.svg',
  S3 = '/images/datasources/light/s3.svg',
  TABLEAU_LOCK = '/images/datasources/light/tableau-lock.svg',
  DATAIKU = '/images/logomarks/dataiku.svg',
  HUBSPOT = '/images/logomarks/hubspot.svg',
  INFORMATICA = '/images/logomarks/informatica.svg',
  INFORMATICA_LOCK = '/images/logomarks/informatica-lock.svg',
  LIGHTDASH = '/images/logomarks/lightdash.svg',
  MICROSOFT_AZURE_ML = '/images/logomarks/microsoft-azure-ml.svg',
  MULESOFT = '/images/logomarks/mulesoft.svg',
  QLIK = '/images/logomarks/qlik.svg',
  QLIK_LOCK = '/images/logomarks/qlik-lock.svg',
  SIGMA = '/images/logomarks/sigma.svg',
  TALEND = '/images/logomarks/talend.svg',
  GOOGLE_SHEETS = '/images/logomarks/google-sheets.svg',
  GITHUB = '/images/logomarks/github.svg',
  UNKNOWN = '/images/logomarks/unknown.svg',
  SIXSENSE = '/images/logomarks/6sense.svg',
  FIFTEENFIVE = '/images/logomarks/15five.svg',
  THREESIXTYLEARNING = '/images/logomarks/360learning.svg',
  ACCELDATA = '/images/logomarks/acceldata.svg',
  ACRYL_DATA = '/images/logomarks/acryl-data.svg',
  ACTIAN_VECTOR = '/images/logomarks/actian-vector.svg',
  ACTIVE_CAMPAIGN = '/images/logomarks/activecampaign.svg',
  ADA = '/images/logomarks/ada.svg',
  ADJUST = '/images/logomarks/adjust.svg',
  ADOBE = '/images/logomarks/adobe.svg',
  ADP_WFN = '/images/logomarks/adp-workforce-now.svg',
  ADROLL = '/images/logomarks/adroll.svg',
  AFFINITY = '/images/logomarks/affinity.svg',
  AIRCALL = '/images/logomarks/aircall.svg',
  AIRTABLE = '/images/logomarks/airtable.svg',
  ALATION = '/images/logomarks/alation.svg',
  ALATION_LOCK = '/images/logomarks/alation-lock.svg',
  ALCHEMER = '/images/logomarks/alchemer.svg',
  ALVIN_AI = '/images/logomarks/alvin-ai.svg',
  AMAZON = '/images/logomarks/amazon.svg',
  AMAZON_CLOUDFRONT = '/images/logomarks/amazon-cloudfront.svg',
  AMAZON_DOCUMENTDB = '/images/logomarks/amazon-document.svg',
  AMAZON_DYNAMODB = '/images/logomarks/amazon-dynamodb.svg',
  AMAZON_FIREHOSE = '/images/logomarks/amazon-kinesis-firehose.svg',
  AMAZON_SELLING_PARTNER = '/images/logomarks/amazon-selling-partner.svg',
  AMPLITUDE = '/images/logomarks/amplitude.svg',
  AMUNDSEN = '/images/logomarks/amundsen.svg',
  AMUNDSEN_LOCK = '/images/logomarks/amundsen-lock.svg',
  ANAPLAN = '/images/logomarks/anaplan.svg',
  ANOMALO = '/images/logomarks/anomalo.svg',
  APACHE_ATLAS = '/images/logomarks/atlas.svg',
  APACHE_ATLAS_LOCK = '/images/logomarks/atlas-lock.svg',
  APACHE_KAFKA = '/images/logomarks/apache-kafka.svg',
  APACHE_SPARK = '/images/logomarks/apache-spark.svg',
  APPCUES = '/images/logomarks/appcues.svg',
  APPFIGURES = '/images/logomarks/appfigures.svg',
  APPLE = '/images/logomarks/apple.svg',
  APPLE_APP_STORE = '/images/logomarks/apple-app-store.svg',
  APPSFLYER = '/images/logomarks/appsflyer.svg',
  ASANA = '/images/logomarks/asana.svg',
  ASSEMBLED = '/images/logomarks/assembled.svg',
  ATLAN = '/images/logomarks/atlan.svg',
  ATLAN_LOCK = '/images/logomarks/atlan-lock.svg',
  ATLASSIAN_CONFLUENCE = '/images/logomarks/atlassian-confluence.svg',
  ATLASSIAN_JIRA = '/images/logomarks/atlassian-jira.svg',
  ATLASSIAN_JIRA_WHITE = '/images/logomarks/atlassian-jira-white.svg',
  ATLASSIAN_OPSGENIE = '/images/logomarks/atlassian-opsgenie.svg',
  AUTH0 = '/images/logomarks/auth0.svg',
  AUTODESK_BIM_360 = '/images/logomarks/autodesk-bim360.svg',
  AWIN = '/images/logomarks/awin.svg',
  AWS_CLOUDTRAIL = '/images/logomarks/aws-cloudtrail.svg',
  AWS_COST_EXPLORER = '/images/logomarks/aws-cost-explorer.svg',
  AWS_INVENTORY = '/images/logomarks/aws-inventory.svg',
  AWS_LAMBDA = '/images/logomarks/aws-lambda.svg',
  BALLOT_READY = '/images/logomarks/ballotready.svg',
  BAMBOOHR = '/images/logomarks/bamboohr.svg',
  BIGCOMMERCE = '/images/logomarks/bigcommerce.svg',
  BIGEYE = '/images/logomarks/bigeye.svg',
  BILLINGPLATFORM = '/images/logomarks/billing-platform.svg',
  BIRDEYE = '/images/logomarks/birdeye.svg',
  BLACKBOARD = '/images/logomarks/blackboard.svg',
  BOX = '/images/logomarks/box.svg',
  BRAINTREE = '/images/logomarks/braintree.svg',
  BRAZE = '/images/logomarks/braze.svg',
  BREX = '/images/logomarks/brex.svg',
  BREVO = '/images/logomarks/brevo.svg',
  BUILDKITE = '/images/logomarks/buildkite.svg',
  BUZZSPROUT = '/images/logomarks/buzzsrpout.svg',
  CALENDLY = '/images/logomarks/calendly.svg',
  CAMPAIGN_MONITOR = '/images/logomarks/campaign-monitor.svg',
  CANNY = '/images/logomarks/canny.svg',
  CANVAS = '/images/logomarks/canvas.svg',
  CAPTERRA = '/images/logomarks/capterra.svg',
  CASTOR_DOC = '/images/logomarks/castor.svg',
  CASTOR_DOC_LOCK = '/images/logomarks/castor-doc-lock.svg',
  CATALOG_GENERIC = '/images/logomarks/cloud.svg',
  CATALOG_GENERIC_LOCK = '/images/logomarks/cloud-lock.svg',
  GENERIC_CATALOG = CATALOG_GENERIC,
  GENERIC_CATALOG_LOCK = CATALOG_GENERIC_LOCK,
  CERTINIA = '/images/logomarks/certinia.svg',
  CHAMELEON = '/images/logomarks/chameleon.svg',
  CHANNEL_ADVISOR = '/images/logomarks/channeladvisor.svg',
  CHARGEBEE = '/images/logomarks/chargebee.svg',
  CHARGEDESK = '/images/logomarks/chargedesk.svg',
  CHARTMOGUL = '/images/logomarks/chartmogul.svg',
  CHORUS_AI = '/images/logomarks/chorus.ai.svg',
  CHURNKEY = '/images/logomarks/churnkey.svg',
  CHURNZERO = '/images/logomarks/churnzero.svg',
  CIMIS = '/images/logomarks/cimis.svg',
  CIN7 = '/images/logomarks/cin7.svg',
  CIRCLE_CI = '/images/logomarks/circleci.svg',
  CLARI = '/images/logomarks/clari.svg',
  CLICKUP = '/images/logomarks/clickup.svg',
  CLIFF_AI = '/images/logomarks/cliff-ai.svg',
  CLOSE = '/images/logomarks/close.svg',
  COLLIBRA = '/images/logomarks/collibra.svg',
  COLLIBRA_LOCK = '/images/logomarks/collibra-lock.svg',
  COMMERCETOOLS = '/images/logomarks/commercetools.svg',
  CONFLUENT_CLOUD = '/images/logomarks/confluent-cloud.svg',
  CONTRAST_SECURITY = '/images/logomarks/contrast-security.svg',
  COUNT = '/images/logomarks/count.svg',
  COUPA = '/images/logomarks/coupa.svg',
  CRITEO = '/images/logomarks/criteo.svg',
  CROSSBEAM = '/images/logomarks/crossbeam.svg',
  CRUNCHBASE = '/images/logomarks/crunchbase.svg',
  CUSTOMER_IO = '/images/logomarks/customer.io.svg',
  D2L_BRIGHTSPACE = '/images/logomarks/d2l-brightspace.svg',
  DATA_WORLD = '/images/logomarks/data-world.svg',
  DATABAND = '/images/logomarks/databand.svg',
  DATADOG = '/images/logomarks/datadog.svg',
  DATAEDO = '/images/logomarks/dataedo.svg',
  DATAFOLD = '/images/logomarks/datafold.svg',
  DATAGALAXY = '/images/logomarks/datagalaxy.svg',
  DATAGALAXY_LOCK = '/images/logomarks/data-galaxy-lock.svg',
  DATAHUB = '/images/logomarks/datahub.svg',
  DB2 = '/images/logomarks/db2.svg',
  DCL_LOGISTICS = '/images/logomarks/dcl-logistics.svg',
  DEAR = '/images/logomarks/dear.svg',
  DECUBE = '/images/logomarks/decube.svg',
  DELIGHTED = '/images/logomarks/delighted.svg',
  DEPUTY = '/images/logomarks/deputy.svg',
  DESTINI = '/images/logomarks/destini.svg',
  DIXA = '/images/logomarks/dixa.svg',
  DOCEBO = '/images/logomarks/docebo.svg',
  DRATA = '/images/logomarks/drata.svg',
  DRIFT = '/images/logomarks/drift.svg',
  DRIP = '/images/logomarks/drip.svg',
  DROPBOX = '/images/logomarks/dropbox.svg',
  DUOPLANE = '/images/logomarks/duoplane.svg',
  E_CONOMIC = '/images/logomarks/e-conomic.svg',
  EASY_POST = '/images/logomarks/easypost.svg',
  ELASTICSEARCH = '/images/logomarks/elasticsearch.svg',
  ELEMENTARY = '/images/logomarks/elementary.svg',
  ELLUCIAN = '/images/logomarks/ellucian-banner.svg',
  ELOQUA = '/images/logomarks/eloqua.svg',
  EMAIL = '/images/logomarks/email.svg',
  EMPLOYMENT_HERO = '/images/logomarks/employment-hero.svg',
  EPICOR_PROPHET_21 = '/images/logomarks/epicor-prophet-21.svg',
  EVENTBRITE = '/images/logomarks/eventbrite.svg',
  EVERHOUR = '/images/logomarks/everhour.svg',
  EXPENSIFY = '/images/logomarks/expensify.svg',
  FACEBOOK = '/images/logomarks/facebook.svg',
  FIGMA = '/images/logomarks/figma.svg',
  FIREBASE = '/images/logomarks/firebase.svg',
  FLEXPORT = '/images/logomarks/flexport.svg',
  FORJ = '/images/logomarks/forj-community.svg',
  FOUNTAIN = '/images/logomarks/fountain.svg',
  FREIGHTVIEW = '/images/logomarks/freightview.svg',
  FRESHBOOKS = '/images/logomarks/freshbooks.svg',
  FRESHCHAT = '/images/logomarks/freshchat.svg',
  FRESHDESK = '/images/logomarks/freshdesk.svg',
  FRESHDESK_CONTACT_CENTER = '/images/logomarks/freshdesk-contact-center.svg',
  FRESHSERVICE = '/images/logomarks/freshservice.svg',
  FRESHSUCCESS = '/images/logomarks/freshsuccess.svg',
  FRESHTEAM = '/images/logomarks/freshteam.svg',
  FRIENDBUY = '/images/logomarks/freshbuy.svg',
  FRONT = '/images/logomarks/front.svg',
  FTP = '/images/logomarks/ftp.svg',
  FULLSTORY = '/images/logomarks/fullstory.svg',
  G2 = '/images/logomarks/g2.svg',
  GAINSIGHT = '/images/logomarks/gainsight-customer-success.svg',
  GEM = '/images/logomarks/gem.svg',
  GIT = '/images/logomarks/git.svg',
  GITLAB = '/images/logomarks/gitlab.svg',
  GLADLY = '/images/logomarks/gladly.svg',
  GOCARDLESS = '/images/logomarks/gocardless.svg',
  GONG = '/images/logomarks/gong.io.svg',
  GOOGLE = '/images/logomarks/google.svg',
  GOOGLE_AD_MANAGER = '/images/logomarks/google-ad-manager.svg',
  GOOGLE_ADS = '/images/logomarks/google-ads.svg',
  GOOGLE_CALENDAR = '/images/logomarks/google-calendar.svg',
  GOOGLE_CAMPAIGN_MANAGER = '/images/logomarks/google-campaign-manager.svg',
  GOOGLE_CHAT = '/images/logomarks/google-chat.svg',
  GOOGLE_CHROME = '/images/logomarks/google-chrome.svg',
  GOOGLE_CLOUD = '/images/logomarks/google-cloud.svg',
  GOOGLE_DISPLAY = '/images/logomarks/google-display.svg',
  GOOGLE_PLAY = '/images/logomarks/google-play.svg',
  GOOGLE_SEARCH_ADS_360 = '/images/logomarks/google-search-ads-360.svg',
  GOOGLE_SEARCH_CONSOLE = '/images/logomarks/google-search-console.svg',
  GOOGLE_TASKS = '/images/logomarks/google-tasks.svg',
  GORGIAS = '/images/logomarks/gorgias.svg',
  GREENHOUSE = '/images/logomarks/grennhouse.svg',
  GREENPLUM = '/images/logomarks/greenplum.svg',
  GREEN_POWER_MONITOR = '/images/logomarks/greenpowermonitor.svg',
  GREPSR = '/images/logomarks/grespr.svg',
  GRIN = '/images/logomarks/grin.svg',
  GURU = '/images/logomarks/guru.svg',
  HARVEST = '/images/logomarks/harvest.svg',
  HDFS = '/images/logomarks/hdfs.svg',
  HEAP = '/images/logomarks/heap.svg',
  HEIGHT = '/images/logomarks/height.svg',
  HELP_SCOUT = '/images/logomarks/help-scout.svg',
  HELPSHIFT = '/images/logomarks/helpshift.svg',
  HEROKU_KAFKA = '/images/logomarks/heroku-kafka.svg',
  HEX = '/images/logomarks/hex.svg',
  HIBOB = '/images/logomarks/hibob.svg',
  HOPIN = '/images/logomarks/hopin.svg',
  IMPACT = '/images/logomarks/impact.svg',
  INCIDENT_IO = '/images/logomarks/incident.io.svg',
  INFOBIP = '/images/logomarks/infobip.svg',
  INSIGHTLY = '/images/logomarks/insightly.svg',
  INSTAGRAM = '/images/logomarks/instagram.svg',
  INTERCOM = '/images/logomarks/intercom.svg',
  INVESTOPEDIA = '/images/logomarks/investopedia.svg',
  IRONCLAD = '/images/logomarks/ironclad.svg',
  IRONSOURCE = '/images/logomarks/ironsource.svg',
  ITERABLE = '/images/logomarks/iterable.svg',
  JAVA = '/images/logomarks/java.svg',
  JENKINS = '/images/logomarks/jenkins.svg',
  JUSTCALL = '/images/logomarks/justcall.svg',
  KANDJI = '/images/logomarks/kandji.svg',
  KENSU = '/images/logomarks/kensu.svg',
  KHOROS_CARE = '/images/logomarks/khoros-care.svg',
  KISSMETRICS = '/images/logomarks/kissmetrics.svg',
  KLAVIYO = '/images/logomarks/klavio.svg',
  KNOWBE4 = '/images/logomarks/knowbe4.svg',
  KONNECT_INSIGHTS = '/images/logomarks/konnect-insights.svg',
  KUSTOMER = '/images/logomarks/kustomer.svg',
  LARIAT_DATA = '/images/logomarks/lariat-data.svg',
  LATTICE = '/images/logomarks/lattica.svg',
  LAUNCH_DARKLY = '/images/logomarks/launchdarkly.svg',
  LEARN_UPON = '/images/logomarks/learnupon.svg',
  LESSONLY = '/images/logomarks/lessonly.svg',
  LEVER = '/images/logomarks/lever.svg',
  LIFTOFF = '/images/logomarks/liftoff.svg',
  LIGHTSPEED = '/images/logomarks/lightspeed-retail.svg',
  LIGHTSUP = '/images/logomarks/lightsup.svg',
  LINEAR = '/images/logomarks/linear.svg',
  LINKEDIN = '/images/logomarks/linkedin.svg',
  LIVECHAT = '/images/logomarks/livechat.svg',
  LOADED_COMMERCE = '/images/logomarks/loaded-commerce.svg',
  LOB = '/images/logomarks/lob.svg',
  LOOP = '/images/logomarks/loop.svg',
  LOOPIO = '/images/logomarks/loopio.svg',
  LUMA = '/images/logomarks/luma.svg',
  MAGENTO = '/images/logomarks/magento.svg',
  MAILCHIMP = '/images/logomarks/mailchimp.svg',
  MAILGUN = '/images/logomarks/mailgun.svg',
  MANDRILL = '/images/logomarks/mandrill.svg',
  MANTA = '/images/logomarks/manta.svg',
  MARIADB = '/images/logomarks/mariadb.svg',
  MARIN_SOFTWARE = '/images/logomarks/marin-software.svg',
  MARKETO = '/images/logomarks/marketo.svg',
  MATILLION = '/images/logomarks/matillion.svg',
  MATTERMOST = '/images/logomarks/mattermost.svg',
  MAVENLINK = '/images/logomarks/mavenlink.svg',
  MAXIO = '/images/logomarks/maxio.svg',
  MEDALLIA = '/images/logomarks/medallia.svg',
  META = '/images/logomarks/meta.svg',
  METAPHOR = '/images/logomarks/metaphor.svg',
  METAPLANE = '/images/logomarks/metaplane.svg',
  MICROSTRATEGY = '/images/logomarks/microstrategy.svg',
  MICROSOFT = '/images/logomarks/microsoft.svg',
  MICROSOFT_AZURE_BLOB_STORAGE = '/images/logomarks/microsoft-azure-blob-storage.svg',
  MICROSOFT_DYNAMICS = '/images/logomarks/microsoft-dynamics.svg',
  MICROSOFT_ONEDRIVE = '/images/logomarks/microsoft-onedrive.svg',
  MICROSOFT_PURVIEW = '/images/logomarks/microsoft-purview.svg',
  MICROSOFT_TEAMS = '/images/logomarks/microsoft-teams.svg',
  MIXMAX = '/images/logomarks/mixmax.svg',
  MIXPANEL = '/images/logomarks/mixpanel.svg',
  MONDAY_COM = '/images/logomarks/monday.com.svg',
  MONGODB = '/images/logomarks/mongodb.svg',
  MONTE_CARLO = '/images/logomarks/monte-carlo.svg',
  MOUNTAIN = '/images/logomarks/mountain.svg',
  MUX = '/images/logomarks/mux.svg',
  NAMELY = '/images/logomarks/namely.svg',
  NCINO = '/images/logomarks/ncino.svg',
  NETSUITE_ANALYTICS = '/images/logomarks/netsuite-suteanalytics.svg',
  NEW_RELIC = '/images/logomarks/new-relic.svg',
  NOTION = '/images/logomarks/notion.svg',
  NYLAS = '/images/logomarks/nylas.svg',
  OBSERVE = '/images/logomarks/observe.svg',
  OCTOPAI = '/images/logomarks/octopai.svg',
  OKTA = '/images/logomarks/okta.svg',
  OPEN_DATA_DC = '/images/logomarks/open-data-dc.svg',
  OPEN_EXCHANGES_RATES = '/images/logomarks/open-exchanges-rates.svg',
  OPEN_AI = '/images/logomarks/openai.svg',
  OPEN_SEARCH = '/images/logomarks/opensearch.svg',
  OPTIMIZELY = '/images/logomarks/optimizely.svg',
  ORBIT_COMMUNITY_PLATFORM = '/images/logomarks/orbit.svg',
  ORDWAY = '/images/logomarks/ordway.svg',
  ORTTO = '/images/logomarks/ortto.svg',
  OS_COMMERCE = '/images/logomarks/oscommerce.svg',
  OUTBRAIN = '/images/logomarks/outbrain.svg',
  OUTREACH = '/images/logomarks/outreach.svg',
  OVALEDGE = '/images/logomarks/ovaledge.svg',
  PAGERDUTY = '/images/logomarks/pagerduty.svg',
  PAGERSHIFT = '/images/logomarks/pagershift.svg',
  PAYPAL = '/images/logomarks/paypal.svg',
  PENDO = '/images/logomarks/pendo.svg',
  PINGDOM = '/images/logomarks/pingdom.svg',
  PINTEREST = '/images/logomarks/pinterest.svg',
  PIPE17 = '/images/logomarks/pipe17.svg',
  PIPEDRIVE = '/images/logomarks/pipedrive.svg',
  PIVOTAL_TRACKER = '/images/logomarks/pivotal-tracker.svg',
  PLAYVOX = '/images/logomarks/playvox.svg',
  POSTHOG = '/images/logomarks/posthog.svg',
  POWERSCHOOL = '/images/logomarks/powerschool.svg',
  PRESTASHOP = '/images/logomarks/prestashop.svg',
  PRODUCTBOARD = '/images/logomarks/productboard.svg',
  PYTHON = '/images/logomarks/python.svg',
  QUALAROO = '/images/logomarks/qualaroo.svg',
  QUALTRICS = '/images/logomarks/qualtrics.svg',
  QUICKBOOKS = '/images/logomarks/quickbooks.svg',
  RAMP = '/images/logomarks/ramp.svg',
  RARIBLE = '/images/logomarks/rarible.svg',
  RECHARGE = '/images/logomarks/recharge.svg',
  RECURLY = '/images/logomarks/recurly.svg',
  REDDIT = '/images/logomarks/reddit.svg',
  RELTIO = '/images/logomarks/reltio.svg',
  REPLY_IO = '/images/logomarks/reply.io.svg',
  RETAILNEXT = '/images/logomarks/retailnext.svg',
  RETENTLY = '/images/logomarks/retently.svg',
  REVEL_SYSTEMS = '/images/logomarks/revel.svg',
  RINGCENTRAL = '/images/logomarks/ringcentral.svg',
  RIPPLING = '/images/logomarks/rippling.svg',
  ROLLBAR = '/images/logomarks/rollbar.svg',
  ROOTLY = '/images/logomarks/rootly.svg',
  SAGE_HR = '/images/logomarks/sage-hr.svg',
  SAGE_INTACCT = '/images/logomarks/sage-intacct.svg',
  SAILTHRU = '/images/logomarks/sailthru.svg',
  SALESLOFT = '/images/logomarks/salesloft.svg',
  SALSIFY = '/images/logomarks/salsify.svg',
  SAMSARA = '/images/logomarks/samsara.svg',
  SAP = '/images/logomarks/sap.svg',
  SAP_CONCUR = '/images/logomarks/sap-concur.svg',
  SCORM = '/images/logomarks/scorm.svg',
  SECODA = '/images/logomarks/secoda.svg',
  SECODA_LOCK = '/images/logomarks/secoda-lock.svg',
  SECURITY_JOURNEY = '/images/logomarks/security-journey.svg',
  SELECT_STAR = '/images/logomarks/select-star.svg',
  SELECT_STAR_LOCK = '/images/logomarks/select-star-lock.svg',
  SENDGRID = '/images/logomarks/sendgrid.svg',
  SERVICE_NOW = '/images/logomarks/servicenow.svg',
  SFTP = '/images/logomarks/sftp.svg',
  SHAREPOINT = '/images/logomarks/sharepoint.svg',
  SHARETRIBE = '/images/logomarks/sharetribe.svg',
  SHIPHERO = '/images/logomarks/shiphero.svg',
  SHIPSTATION = '/images/logomarks/shipstation.svg',
  SHOPIFY = '/images/logomarks/shopify.svg',
  SHOPWARE = '/images/logomarks/shopware.svg',
  SHORT_IO = '/images/logomarks/short.io.svg',
  SIFFLET = '/images/logomarks/sifflet.svg',
  SIMPLECAST = '/images/logomarks/simplecast.svg',
  SIMPLESAT = '/images/logomarks/simplesat.svg',
  SINGLESTORE = '/images/logomarks/singlestore.svg',
  SISENSE = '/images/logomarks/sisens.svg',
  SKILLJAR = '/images/logomarks/skilljar.svg',
  SKUVAULT = '/images/logomarks/skuvault.svg',
  SLAB = '/images/logomarks/slab.svg',
  SMADEX = '/images/logomarks/smadex.svg',
  SNAPCHAT = '/images/logomarks/snapchat.svg',
  SNOWPLOW = '/images/logomarks/snowplow.svg',
  SODA = '/images/logomarks/soda.svg',
  SONARQUBE = '/images/logomarks/sonarqube.svg',
  SPLIT_IO = '/images/logomarks/split.io.svg',
  SPLUNK = '/images/logomarks/splunk.svg',
  SPOTIFY = '/images/logomarks/spotify.svg',
  SPREE_COMMERCE = '/images/logomarks/spree-commerce.svg',
  SPROUT_SOCIAL = '/images/logomarks/sprout-social.svg',
  SQUARE = '/images/logomarks/square.svg',
  SQUARESPACE = '/images/logomarks/squarespace.svg',
  SSIS = '/images/datasources/light/mssql.svg',
  STACK_ADAPT = '/images/logomarks/stackadapt.svg',
  STATSIG = '/images/logomarks/statsig.svg',
  STRIPE = '/images/logomarks/stripe.svg',
  STYLIGHT = '/images/logomarks/stylight.svg',
  SUBSCRIPT = '/images/logomarks/subscriipt.svg',
  TABOOLA = '/images/logomarks/taboola.svg',
  TALKDESK = '/images/logomarks/talkdesk.svg',
  TALKWALKER = '/images/logomarks/talkwalker.svg',
  TEAMWORK_COM = '/images/logomarks/teamwork.svg',
  TEMPO_IO = '/images/logomarks/tempo.io.svg',
  TERADATA = '/images/logomarks/teradata.svg',
  TERRAFORM = '/images/logomarks/terraform.svg',
  THE_TRADE_DESK = '/images/logomarks/the-trade-desk.svg',
  THOUGHT_SPOT = '/images/logomarks/thought-spot.svg',
  TIKTOK = '/images/logomarks/tiktok.svg',
  TOGGL = '/images/logomarks/toggl.svg',
  TRANSCEND = '/images/logomarks/transcend.svg',
  TRELLO = '/images/logomarks/trello.svg',
  TRISOLUTE = '/images/logomarks/trisolute.svg',
  TWILIO = '/images/logomarks/twilio.svg',
  TYPEFORM = '/images/logomarks/typeform.svg',
  UPLAND = '/images/logomarks/upland.svg',
  USERVOICE = '/images/logomarks/uservoice.svg',
  VALIDIO = '/images/logomarks/validio.svg',
  VEEVA = '/images/logomarks/veeva.svg',
  VERIZON_MEDIA = '/images/logomarks/verizon-media.svg',
  VITALLY = '/images/logomarks/vitally.svg',
  VONAGE = '/images/logomarks/vonage.svg',
  VUETIFY = '/images/logomarks/vuetify.svg',
  WEB_SCRAPER = '/images/logomarks/web-scraper.svg',
  WEBHOOKS_DARK = '/images/logomarks/webhooks_dark.svg',
  WEBHOOKS = '/images/logomarks/webhooks.svg',
  WHEN_I_WORK = '/images/logomarks/when-i-work.svg',
  WHEREFOUR = '/images/logomarks/wherefour.svg',
  WIKIPEDIA = '/images/logomarks/wikipedia.svg',
  WOOCOMMERCE = '/images/logomarks/woocommerce.svg',
  WORDPRESS = '/images/logomarks/wordpress.svg',
  WORKABLE = '/images/logomarks/workable.svg',
  WORKDAY = '/images/logomarks/workday.svg',
  WORKFLOW_MAX = '/images/logomarks/workflowmax.svg',
  WRIKE = '/images/logomarks/wrike.svg',
  X = '/images/logomarks/x.svg',
  XERO = '/images/logomarks/xero.svg',
  XRAY = '/images/logomarks/xray.svg',
  YAHOO = '/images/logomarks/yahoo.svg',
  YOTPO = '/images/logomarks/yotpo.svg',
  YOUTUBE = '/images/logomarks/youtube.svg',
  ZEENEA = '/images/logomarks/zeenea.svg',
  ZEN_CART = '/images/logomarks/zen-cart.svg',
  ZENDESK_CHAT = '/images/logomarks/zendesk-chat.svg',
  ZENDESK_SELL = '/images/logomarks/zendesk-sell.svg',
  ZENDESK_SUNSHINE = '/images/logomarks/zendesk-sunshine.svg',
  ZENDESK_SUPPORT = '/images/logomarks/zendesk-support.svg',
  TRINET = '/images/logomarks/trinet.svg',
  ZINGTREE = '/images/logomarks/zingtree.svg',
  ZOHO_BOOKS = '/images/logomarks/zoho-books.svg',
  ZOHO_CAMPAIGNS = '/images/logomarks/zoho-campaigns.svg',
  ZOHO_CRM = '/images/logomarks/zoho-crm.svg',
  ZOOM = '/images/logomarks/zoom.svg',
  ZUORA = '/images/logomarks/zuora.svg',
}

export const getProviderIconSrc = (provider?: string): ProviderIcons => ProviderIcons[provider as keyof typeof ProviderIcons] || ProviderIcons.UNKNOWN;

export default ProviderIcons;
